"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = ButtonGroup;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _uiKit = require("@cian/ui-kit");
var _widgetContext = require("../../../context/widgetContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ButtonGroup(_ref) {
  let {
    buttons,
    currentActiveValue,
    onChange,
    fullWidth,
    testId
  } = _ref;
  const {
    isDesktop,
    isMyHome
  } = React.useContext(_widgetContext.widgetContext);
  const isDesktopView = isDesktop && !isMyHome; // Для моего дома необхъодимо использовать мобильные компоненты

  const handleClick = React.useCallback(value => {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-name": testId
  }, /*#__PURE__*/React.createElement("div", null, buttons.map((_ref2, index) => {
    let {
      label,
      value
    } = _ref2;
    const TextComponent = isDesktopView ? _uiKit.UIText2 : _uiKit.UIText1;
    return /*#__PURE__*/React.createElement("button", {
      key: index,
      type: "button",
      onClick: () => handleClick(value),
      className: (0, _classnames.default)(styles['button'], isDesktopView && styles['desktop'], value === currentActiveValue && styles['active'], fullWidth && styles['button-equal-grow'])
    }, /*#__PURE__*/React.createElement(TextComponent, null, label));
  })));
}